import { Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import { TextProps } from '../../../redux/theme/types'

interface TitleProps extends TextProps {
  containerStyle?: StyleProp<ViewStyle>
}

export const Title: FunctionComponent<TitleProps> = ({ containerStyle, ...props }) => (
  <View style={containerStyle}>
    <Text numberOfLines={1} {...props} />
  </View>
)
